import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55d8a1fb/src/components/layout.js";
import Layout from "../../../components/layout";
import { Link } from "gatsby";
import styled from "styled-components";
import { PrimaryButton } from "../../../components/Buttons";
import { SecondaryButton } from "../../../components/Buttons";
import '../form.css';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 className="form-title">Does your city have an existing rent control ordinance?</h1>
    <p className="form-description">Most local rent control laws provide better protection than the new statewide law. The statewide law will only apply in cases where your local coverage is not as good. Click on your city below or select ‘My city is not listed’ to continue.</p>
    <ul className="cities">
  <li><Link to={`/coverage/existing-rent-control-check/alameda`} mdxType="Link">Alameda</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/berkeley`} mdxType="Link">Berkeley</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/beverly-hills`} mdxType="Link">Beverly Hills</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/east-palo-alto`} mdxType="Link">East Palo Alto</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/hayward`} mdxType="Link">Hayward</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/los-angeles`} mdxType="Link">Los Angeles</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/los-gatos`} mdxType="Link">Los Gatos</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/mountain-view`} mdxType="Link">Mountain View</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/oakland`} mdxType="Link">Oakland</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/palm-springs`} mdxType="Link">Palm Springs</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/richmond`} mdxType="Link">Richmond</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/san-francisco`} mdxType="Link">San Francisco</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/san-jose`} mdxType="Link">San Jose</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/santa-monica`} mdxType="Link">Santa Monica</Link></li>
  <li><Link to={`/coverage/existing-rent-control-check/west-hollywood`} mdxType="Link">West Hollywood</Link></li>
    </ul>
    <div className="form-button-container">
      <PrimaryButton to="/coverage/overrides" mdxType="PrimaryButton">My city is not listed</PrimaryButton>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      